import React from 'react';
import PropTypes from 'prop-types';
import store from '../../store'
import moment from 'moment';
import admin from '../../api/admin';
import confirmAction from '../../utils/confirm';
import {edit_game_path, game_path } from 'routes';

class Game extends React.Component {
  deleteEvent = () => {
    const {id} = this.props.game;
    confirmAction(() => {
      admin.deleteGame(id).then(() => location.reload());
    });
  }

  render() {
    const { game } = this.props;
    const user = store.getState().current_user;
    const locale = user.locale;
    const controls = this.props.t_controls.controls;

    function pastGame() {
      return <div className="game-info game-info-classic">
        <p className="game-info-subtitle">{game.arena} 
          <time dateTime="2018-04-17"> {moment(`${game.started_at}`).format('DD MMMM, YYYY')}</time>
        </p>
        <h3 className="game-info-title">{game.description}</h3>
        <div className="game-info-main">
          <div className="game-info-team game-info-team-first">
            <figure>
              <img style={{width: "auto", height: "99px"}} src={game.home_team_logo} />
            </figure>
            <div className="game-result-team-name">{game.home_team_name}</div>
          </div>
          <div className="game-result-middle">
            <div className="game-result-score-wrap">
              <div className={game.home_goals > game.away_goals ? "game-result-team-win" : "low-result"}>
                <div className={`game-info-score ${game.home_goals > game.away_goals ? 'game-result-team-win' : 'low-result'}`}>{game.home_goals}</div>
                { game.home_goals > game.away_goals && <span className="game-result-team-label game-result-team-label-top">Win</span> }
              </div>
              <div className="game-result-score-divider">
                <svg x="0px" y="0px" width="7px" height="21px" viewBox="0 0 7 21" enableBackground="new 0 0 7 21" xmlSpace="preserve">
                  <g>
                    <circle cx="3.5" cy="3.5" r={3} />
                    <path d="M3.5,1C4.879,1,6,2.122,6,3.5S4.879,6,3.5,6S1,4.878,1,3.5S2.122,1,3.5,1 M3.5,0C1.567,0,0,1.567,0,3.5S1.567,7,3.5,7      S7,5.433,7,3.5S5.433,0,3.5,0L3.5,0z" />
                  </g>
                  <g>
                    <circle cx="3.695" cy="17.5" r={3} />
                    <path d="M3.695,15c1.378,0,2.5,1.122,2.5,2.5S5.073,20,3.695,20s-2.5-1.122-2.5-2.5S2.316,15,3.695,15 M3.695,14      c-1.933,0-3.5,1.567-3.5,3.5s1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5S5.628,14,3.695,14L3.695,14z" />
                  </g>
                </svg>
              </div>
              <div className={game.away_goals > game.home_goals ? "game-result-team-win" : "low-result"}>
              <div className={`game-info-score ${game.away_goals > game.home_goals ? 'game-result-team-win' : 'low-result'}`}>{game.away_goals}</div>
                { game.away_goals > game.home_goals && <span className="game-result-team-label game-result-team-label-top">Win</span> }
              </div>
            </div>
            { game.score_status_label
              && <div className="game-score-status-badge">{game.score_status_label}</div>
            }
            <div className="game-result-divider-wrap"><span className="game-info-team-divider">VS</span></div>
            <a className="button button-sm button-primary" href={`${game_path(game.id, { locale: locale })}`}>{`${controls.details}`}</a>
          </div>
          <div className="game-info-team game-info-team-second">
            <figure>
              <img style={{width: "auto", height: "99px"}} src={game.away_team_logo} />
            </figure>
            <div className="game-result-team-name">{game.away_team_name}</div>
          </div>
        </div>
      </div>;
    }

    function futureGame() {
      return <div className="game-info">
        <p className="game-info-subtitle">{game.arena}</p>
        <h3 className="game-info-title">{game.description}</h3>
        <div className="game-info-main">
          <div className="game-info-team game-info-team-first">
            <figure>
              <img style={{width: "auto", height: "99px"}} src={game.home_team_logo} />
            </figure>
            <div className="game-result-team-name">{game.home_team_name}</div>
          </div>
          <div className="game-info-middle game-info-middle-vertical">
            <time className="time-big">
              <span className="heading-3">{moment(`${game.started_at}`).format('ddd DD')}</span>{moment(`${game.started_at}`).format('MMM YYYY')}
            </time>
            <div className="game-result-divider-wrap"><span className="game-info-team-divider">VS</span></div>
            <div className="group-sm">
              <time className="time-big">
                <span className="heading-3">{moment(`${game.started_at}`).format('HH:mm')}</span>
              </time>
              <a className="button button-sm button-primary" href={`${game_path(game.id, { locale: locale })}`}>{`${controls.details}`}</a>
            </div>
          </div>
          <div className="game-info-team game-info-team-second">
            <figure>
              <img style={{width: "auto", height: "99px"}} src={game.away_team_logo} />
            </figure>
            <div className="game-result-team-name">{game.away_team_name}</div>
          </div>
        </div>
      </div>;
    }

    return (
      <article className="game-result">
        <div className="tag">
          <div className="badge badge-red">
            Game
          </div>
          <div className="badge-tournament-logo">
            <img src={game.tournament_logo} />
          </div>
        </div>
        {game.is_future ? futureGame() : pastGame()}
        { user?.admin &&
          <div className="game-buttons">
            <a className="button button-sm button-primary" href={`${edit_game_path(game.id, { locale: locale })}`}>{`${controls.edit}`}</a>
            <button className="button button-sm button-primary" onClick={this.deleteEvent}>{`${controls.delete}`}</button>
          </div>
        }
      </article>
    )
  }
}

Game.propTypes = {
  game: PropTypes.object.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default Game;
